import { Stack } from '@packages/fenrir/components';

import { AssetInformationCategory } from './asset-information-category';
import { AssetInformationField } from './asset-information-field';
import { AssetInformationImportance } from './asset-information-importance';
import { AssetInformationLastSeen } from './asset-information-last-seen';
import { AssetInformationLastSuccessfulScan } from './asset-information-last-successful-scan';
import { AssetInformationOs } from './asset-information-os';
import { AssetInformationRiskCount } from './asset-information-risk-count';
import { AssetInformationRiskScore } from './asset-information-risk-score';
import { AssetInformationSources } from './asset-information-sources';
import { AssetInformationTags } from './asset-information-tags';

const AssetInformationRoot = ({ children }: React.PropsWithChildren) => {
  return (
    <Stack
      direction="row"
      sx={{ gap: 4, alignItems: 'flex-start', justifyContent: 'flex-start' }}
    >
      {children}
    </Stack>
  );
};

export const AssetInformation = {
  Root: AssetInformationRoot,
  Field: AssetInformationField,
  Os: AssetInformationOs,
  Sources: AssetInformationSources,
  Importance: AssetInformationImportance,
  Category: AssetInformationCategory,
  Tags: AssetInformationTags,
  LastSeen: AssetInformationLastSeen,
  LastSuccessfulScan: AssetInformationLastSuccessfulScan,
  RiskScore: AssetInformationRiskScore,
  RiskCount: AssetInformationRiskCount,
};
